import { Link } from "react-router-dom";

export default Link